import React, { Suspense } from 'react';
import ReactRootProviders from '@client/src/global/context/ReactRootProviders';
import { react2angular } from 'react2angular';
import { UserSessionProvider } from '@client/src/global/context/UserSessionProvider';
import { RedirectionPage } from '@app/pages/redirection';
import { RedirectionPageProps } from '@app/pages/redirection/types';

function WrappedRedirectionPage(props: RedirectionPageProps) {
  return (
    <ReactRootProviders>
      <UserSessionProvider>
        <Suspense fallback={null}>
          <RedirectionPage {...props} />
        </Suspense>
      </UserSessionProvider>
    </ReactRootProviders>
  );
}

export const AngularRedirectionPage = react2angular(WrappedRedirectionPage, ['platformName']);
